import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotification = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 18.3667V16.9601H6.69545V9.96187C6.69545 8.70058 7.08475 7.58537 7.86334 6.61622C8.64178 5.64708 9.64125 5.02722 10.8617 4.75665V4.17235C10.8617 3.84675 10.9756 3.56992 11.2034 3.34186C11.4311 3.11395 11.7076 3 12.0329 3C12.3584 3 12.6353 3.11395 12.8636 3.34186C13.0922 3.56992 13.2064 3.84675 13.2064 4.17235V4.75665C14.4269 5.02722 15.4264 5.64708 16.2048 6.61622C16.9834 7.58537 17.3727 8.70058 17.3727 9.96187V16.9601H19.0682V18.3667H5ZM12.0324 21C11.5659 21 11.1669 20.834 10.8357 20.502C10.5043 20.17 10.3386 19.7708 10.3386 19.3046H13.7295C13.7295 19.7724 13.5634 20.1719 13.2311 20.5032C12.8987 20.8344 12.4992 21 12.0324 21ZM8.10227 16.9601H15.9659V9.96187C15.9659 8.87612 15.5821 7.94942 14.8144 7.18177C14.0466 6.41396 13.1198 6.03005 12.0341 6.03005C10.9483 6.03005 10.0216 6.41396 9.25375 7.18177C8.48609 7.94942 8.10227 8.87612 8.10227 9.96187V16.9601Z",
		fill: "currentColor"
	})
});
export default SvgNotification;
